module.exports = __webpack_public_path__ + "ab0e3a832e6ac3010f031d73b3895e85.png";